<template>
  <section class="open-positions position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-9 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-10 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-11 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-12 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="positions-header text-center">
            <div class="positions-section-label">
              <h4>{{ content.header.label }}</h4>
            </div>
            <div class="positions-main-title">
              <h2>{{ content.header.title }}</h2>
            </div>
            <div class="positions-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-container">
      <div class="row">
        <div 
          v-for="(position, index) in content.positions" 
          :key="index"
          class="col-lg-6 col-md-12 mb-4"
        >
          <div class="position-card">
            <div class="position-bg">
              <div class="block-shape-1"></div>
              <div class="block-shape-2"></div>
            </div>
            <div class="position-content">
              <div class="position-header">
                <h3>{{ position.title }}</h3>
                <div class="position-location">
                  <i class="icon-03"></i>
                  <span>{{ position.location }}</span>
                </div>
              </div>
              <div class="position-description">
                <p>{{ position.description }}</p>
              </div>
              <div class="position-requirements">
                <h4>Requirements:</h4>
                <ul>
                  <li v-for="(requirement, reqIndex) in position.requirements" :key="reqIndex">
                    {{ requirement }}
                  </li>
                </ul>
              </div>
              <div class="position-actions">
                <a :href="position.applyLink" class="apply-btn">
                  <i class="icon-02"></i> Apply Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CareersPositionsComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-9 {
  top: 18%;
  left: 12%;
  width: 105px;
  height: 105px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-10 {
  bottom: 30%;
  right: 12%;
  width: 75px;
  height: 75px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-11 {
  top: 45%;
  left: 8%;
  width: 125px;
  height: 125px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-12 {
  bottom: 18%;
  right: 18%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

/* Open Positions Section */
.open-positions {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.positions-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.positions-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.positions-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.positions-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.position-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 30px;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.position-card:hover {
  box-shadow: 0 25px 50px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.position-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.position-content {
  position: relative;
  z-index: 2;
}

.position-header {
  margin-bottom: 20px;
}

.position-header h3 {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.position-location {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #F6EC4F;
  font-size: 14px;
  font-weight: 500;
}

.position-location i {
  font-size: 16px;
}

.position-description {
  margin-bottom: 20px;
}

.position-description p {
  font-size: 16px;
  color: #fff;
  line-height: 1.6;
  margin: 0;
}

.position-requirements {
  margin-bottom: 25px;
}

.position-requirements h4 {
  font-size: 16px;
  font-weight: 600;
  color: #F6EC4F;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.position-requirements ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.position-requirements li {
  font-size: 14px;
  color: #fff;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.position-requirements li::before {
  content: '•';
  color: #F6EC4F;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.position-actions {
  margin-top: 20px;
}

.apply-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 25px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
  border: none;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Archivo', sans-serif;
  text-decoration: none;
  box-shadow: 0 4px 15px rgba(246, 236, 79, 0.2);
  position: relative;
  overflow: hidden;
}

.apply-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.apply-btn:hover {
  box-shadow: 0 8px 20px rgba(246, 236, 79, 0.3);
  text-decoration: none;
  color: #00061A;
}

.apply-btn:hover::before {
  left: 100%;
}

.apply-btn i {
  transition: transform 0.3s ease;
}

/* Responsive Design */
@media (max-width: 767px) {
  .positions-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .positions-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .position-card {
    padding: 30px 20px;
  }
}

@media (max-width: 399px) {
  .see__pad {
    padding: 60px 0;
  }
  
  .positions-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
